<template>
  <div class="container order_success">
    <div class="head_box">
      <div class="logo" v-if="false">
        <router-link to="/" target="_blank">
          <img class="img_item cur_pointer" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div>
    </div>
    <div class="content">
      <div class="left_suc">
        <div class="icon_suc">
          <img class="suc_img" :src="require('@/assets/img/ggg.png')" alt />
        </div>
        <div class="fz30 mb20">支付成功</div>
        <div class="fz18 mb40">我们尽快为您处理</div>
        <div class="link mb35">
          <div class="link_item cur_pointer">
            <span class="col_fff" @click="linkUrlReload(orderPath)">查看订单</span>
          </div>
          <div class="link_item cur_pointer" @click="linkUrlReload('/')">继续逛逛</div>
        </div>
        <div class="fz12 tips">
          重要提示：商城不会以订单异常、系统升级为由，
          <br />要求您点击任何链接进行退款。
        </div>
      </div>
      <div class="right_itr">
        <div class="total">
          <span class="color_red">本次支付总额：</span>
          <span>{{totalFee | priceValue}}元</span>
        </div>
        <div class="itr_item" v-for="(item,index) in list" :key="index">
          <div class="item">
            <span>订单编号：</span>
            <span>{{item.orderBatchNo || item.orderNo}}</span>
          </div>
          <!-- <div class="item color_red">
              <span v-show="item.payFee>0">应付总额：</span>
              <span v-show="item.payFee>0" class="pright">{{item.payFee | priceValue}}元</span>
              <span v-show="item.paidFee>0">已付总额：</span>
              <span v-show="item.paidFee>0" class="pright">{{item.paidFee | priceValue}}元</span>
              <span v-show="item.needToPay>0">剩余待付：</span>
              <span v-show="item.needToPay>0">{{item.needToPay | priceValue}}元</span>
            </div> -->
          <div class="item">
            <span>配送时间：</span>
            <span v-show="item.deliveryDayType===1">工作日配送（适用于办公地址）</span>
            <span v-show="item.deliveryDayType===2">仅双休日节假日送货</span>
            <span v-show="item.deliveryDayType===3">工作日_双休日_节假日均可送货</span>
          </div>
          <div class="item">
            <div class="mb6">
              <span>收货信息：</span>
              <span>{{item.consignee}}</span>
              <span class="pl16">{{item.consigneeTel | phoneInter}}</span>
            </div>
            <div class="pl70">
              <span>{{item.deliveryProName}}</span>
              <span class="pl_addr">{{item.deliveryCityName}}</span>
              <span class="pl_addr">{{item.deliveryDisName}}</span>
              <span class="pl_addr" v-if="item.deliveryTownName">{{item.deliveryTownName}}</span>
              <span class="pl_addr">{{item.deliveryAddr}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="QR" v-if="!isShopView">
        <img class="QR_img" :src="require('@/assets/img/qrCode3.jpg')" alt />
        <p>关注多比网微信公众号 随时跟踪订单</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: { title: "下单成功" },
  name: "successPay",
  props: {
    OrderSuccess: {
      type: Function,
      default: () => {},
    },
    PtOrderSuccess: {
      type: Function,
      default: () => {},
    },
    SingleOrderSuccess: {
      type: Function,
      default: () => {},
    },
    orderPath: {
      type: String,
      default: "/personalCenter/myOrder",
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      totalFee: 0,
    };
  },
  mounted() {
    if (!this.$route.query.out_trade_no) {
      return;
    }
    // console.log('query', this.$route.query);
    if (this.$route.query.come === "order") {
      this.singlegetorderSuccess(this.$route.query.out_trade_no);
      return;
    }
    if (this.$route.query.come === "plate") {
      this.ptGetorderSuccess(this.$route.query.out_trade_no);
      return;
    }
    this.getorderSuccess(this.$route.query.out_trade_no);
  },
  methods: {
    linkUrlReload(url) {
      // 多页面 注意刷新
      let newUrl = this.$router.resolve(url);
      window.open(newUrl.href, "_self");
    },
    getorderSuccess(payOrderNo) {
      this.OrderSuccess({ payOrderNo }).then((res) => {
        // console.log("支付成功后接口", res);
        this.totalFee = res.data[0].curPayFee;
        this.list = res.data[0].orderBatchList;
      });
    },
    ptGetorderSuccess(payOrderNo) {
      this.PtOrderSuccess({ payOrderNo }).then((res) => {
        // console.log("支付成功后接口", res);
        this.totalFee = res.data[0].curPayFee;
        this.list = res.data[0].orderBatchList;
      });
    },
    singlegetorderSuccess(payOrderNo) {
      this.SingleOrderSuccess({ payOrderNo }).then((res) => {
        // console.log("支付成功后接口", res);
        this.totalFee = res.data[0].curPayFee;
        this.list = res.data[0].orderList;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order_success {
  margin-bottom: 420px;
  .head_box {
    margin-top: 37px;
    margin-bottom: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
  }
  .content {
    min-height: 442px;
    border: 1px solid #b39d9d;
    box-sizing: border-box;
    display: flex;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 400;
    position: relative;
    .left_suc {
      width: 480px;
      background: #ffb134;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 60px;
      color: #fff;
      margin-right: 117px;
      .icon_suc {
        width: 56px;
        height: 56px;
        background: #ffffff;
        border-radius: 50%;
        margin-bottom: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        .suc_img {
          width: 33px;
          height: 30px;
        }
      }
      .link {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        padding: 0 110px;
        justify-content: space-between;
        .link_item {
          width: 116px;
          height: 25px;
          text-align: center;
          line-height: 23px;
          box-sizing: border-box;
          border: 1px solid #fff;
          .col_fff {
            color: #ffffff;
          }
        }
      }
      .tips {
        line-height: 22px;
        text-align: center;
        font-weight: 300;
      }
    }
    .right_itr {
      padding-top: 70px;
      padding-bottom: 200px;
      .total {
        margin-bottom: 30px;
        font-weight: 600;
      }
      .itr_item {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0px;
        }
        .item {
          font-size: 14px;
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0px;
          }
          .pright {
            padding-right: 20px;
          }
        }
      }
    }
    .QR {
      position: absolute;
      bottom: 20px;
      right: 30px;
      width: 120px;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      .QR_img {
        width: 106px;
        height: 106px;
      }
    }
  }
  .fz30 {
    font-size: 30px;
  }
  .fz18 {
    font-size: 18px;
  }
  .fz12 {
    font-size: 12px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .mb40 {
    margin-bottom: 40px;
  }
  .mb35 {
    margin-bottom: 35px;
  }
  .pl_addr {
    padding-left: 4px;
  }
  .pl16 {
    padding-left: 16px;
  }
  .pl70 {
    padding-left: 70px;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .color_red {
    color: #ff0000;
  }
}
</style>